export default __webpack_public_path__ + "static/media/blockchain-image-5steg.2a9f5a18.jpg";